import { Organization } from "@/features-root-user/service/organization";
import { atom } from "jotai";

export type OrganizationsDialogType = "delete" | "delete_all" | null;

export const organizationsDialogAtom = atom<OrganizationsDialogType>(null);
export const organizationsCurrentRowAtom = atom<Organization | null>(null);
